module.exports = __webpack_public_path__ + "img/logo.9a994ce7.svg";